import React, { Component } from "react";
//import ReactDOM from "react-dom";
//import classNames from "classnames";
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
} from "reactstrap";
import Swal from "sweetalert2";
//import { rgbToHex } from "@coreui/coreui/dist/js/coreui-utilities";
import Axios from "axios";

//import Car from "../carbodyparts/car";
//import CarDentTable from "../carbodyparts/CarDentTable";
import { configuration } from "../appConfig";
import { connect } from "react-redux";
import PlotDentOnImage from "./PlotDentOnImage/PlotDentOnImage";
import PlotDentOnExtraImage from "./PlotDentOnImage/PlotDentOnExtraImage";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');


class Clients extends Component {
  state = {
    words: {},
    lang: "En",
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
    partDetails: null,
    twoDView: true,
    vinNumber: null,

    vinfolderList: [],
    showTwoDView: true,
    selectedPartInfo: [],
    scanresult: [],
    extTmages: "",
    img: "",
    imgPath: "",
    openModal: false,
    title: "",
    bulkImages: [],
    extraImages: [],
    base64Images: [], // State to store base64 encoded images
  };
  componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    // this.getData(selectedFile);
    this.getClients();
    this.getLang();
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;

    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  getClients = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");

    const url = configuration.getClients;
    if (partnerId) {
      const response = await Axios.get(
        url + "?vin=" + selectedFile + "&partnerId=" + partnerId
      );
      if (response.data && response.data.length) {
        this.setState({
          vinfolderList: response.data,
        });
      } else {
        //  alert('Data not available.')
      }

      //console.table(response.data);
    } else {
      this.props.history.push("/login");
    }
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };

  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  };

  capture = async (e) => {
    const { files } = e.target;
    const base64Images = [];

    // Iterate through each file to convert it to base64
    for (let i = 0; i < files.length; i++) {
      const base64 = await this.getBase64(files[i]);
      base64Images.push(base64);
    }

    // Set base64Images in state and enable upload button
    this.setState({
      base64Images: base64Images,
      disableUploadBtn: false
    });
  };

  uploadExtraImages = () => {
    const { base64Images } = this.state;

    // Check if there are images to upload
    if (!base64Images || base64Images.length === 0) {
      return;
    }

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const uploadExtraImagesurl = configuration.uploadExtraImages;
    let uploadedImageCount = 0;

    base64Images.forEach((base64, index) => {
      // const mulData = new FormData();
      // mulData.append('img', base64);
      // mulData.append('vin', vin);
      // mulData.append('partnerId', partnerId);
      // mulData.append('partName', this.state.bulkImages.length > 0 ? `bulkImage-${this.state.bulkImages.length + index + 1}` : `bulkImage-${index + 1}`);

      let payload = {
        img: base64,
        vin: vin ,
        partnerId: partnerId,
        partName:  this.state.bulkImages.length > 0 ? `bulkImage-${this.state.bulkImages.length + index + 1}` : `bulkImage-${index + 1}`,
      };


      var config = {
        onUploadProgress: (progressEvent) => {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          this.setState({ uploadPercent: percentCompleted });
        },
      };

      Axios.post(uploadExtraImagesurl, payload, config)
        .then((res) => {
          uploadedImageCount++;
          Toast.fire({
            type: "success",
            title: "Image Uploaded successfully",
          });
          if (uploadedImageCount === base64Images.length) {
            window.location.reload(false);
            this.setState({ uploading: false });
          }
        })
        .catch((err) => {
          this.setState({ uploading: false });
        });
    });
  };

  // uploadExtraImages = () => {

  //   if (this.state.extTmages.length) {
  //     var i;
  //     for (i = 0; i < this.state.extTmages.length; i++) {

  //       const partnerId = localStorage.getItem("partnerId");
  //       const vin = localStorage.getItem("selectedFile");
  //       const data = new FormData();
  //       data.append("img", this.state.extTmages[i]);
  //       data.append("title", this.state.title);
  //       data.append("partnerId", partnerId);
  //       const uploadExtraImagesurl = configuration.PostClients;

  //       Axios.post(uploadExtraImagesurl, data)
  //         .then((res) => {
  //           Toast.fire({
  //             type: "success",
  //             title: "Image Uploaded successfully",
  //           });
  //           this.setState({ extTmages: "" });
  //           window.location.reload(false);
  //         })
  //         .catch((err) => {
  //         });
  //     }
  //   }
  // };

  delete = (imageObj) => {
    const url = configuration.deleteImage;
    const confirm = window.confirm("Are you sure want to delete this ?");
    const data = new FormData();
    data.append("id", imageObj.id)
    data.append("part_name", imageObj.part)
    data.append("vin", imageObj.vin)
    data.append("partnerId", localStorage.getItem("partnerId"));
    data.append("is_type", "web_app");
    data.append("is_extara_image", '2');
    // data.append("tblName", "client-list");
    if (confirm) {
      Axios.post(url, data)
        .then((res) => {
          Toast.fire({
            type: "success",
            title: "Deleted successfully",
          });
          // this.setState({ extTmages: '' });
          window.location.reload(false);
        })
        .catch((err) => {
        });
    }
  };
  openModal = (image, path) => {
    this.setState({
      openModal: !this.state.openModal,
      img: image,
      imgPath: path,
    });
  };

  render() {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    const { img } = this.state;

    //const dentInfo = scanResult.resultTXT;

    return (
      <div className="animated fadeIn">
        <Col xs="12" sm="12">
          <Card>
            <CardHeader>
              <Link className="glass" to="/qrlist">
                <button
                  style={{ marginRight: 10 }}
                  className="btn btn-danger btn-sm pull-left"
                >
                  {"<<"} <i className="fa fa-dot-circle-o"></i>
                </button>
              </Link>
              {/* <small className="pull-right rightLbl">Order No : {orderNumber}</small> */}
              <small> VIN Number : {localStorage.getItem("selectedFile")}</small>
              <button
                className="btn btn-danger  pull-right"
                disabled={!this.state.extTmages}
                onClick={() => this.uploadExtraImages()}
              >
                <i className="fa fa-upload"></i> {"upload"}
              </button>
              {/* <input
                type="file"
                className="pull-right"
                name="image"
                onChange={(e) => this.setState({ extTmages: e.target.files[0] })}
              /> */}
              <div className="pull-right pr-2">
                <div className="input-group-append dropdown">
                  <button
                    className="dropdown-toggle btn btn-success pull-right"
                    type="button"
                    aria-expanded="false"
                    aria-haspopup="true"
                    aria-label="Dropdown toggle"
                    onClick={(e) => {
                      this.refs.KM.click();
                    }}
                  >
                    <i className="fa fa-picture" /> Select Logo
                  </button>
                  <input
                    type="file"
                    name="image"
                    id="file"
                    ref="KM"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      {
                        this.capture(e);
                        this.setState({ extTmages: e.target.files });
                      }
                    }
                  />
                  <div
                    className="dropdown-menu"
                    role="menu"
                    aria-hidden="true"
                    data-popper-placement="bottom-start"
                  ></div>
                </div>
              </div>

              <div className="pull-right pr-2">
                <div className="input-group-append dropdown">
                  <input
                    type="text"
                    name="title"
                    required
                    className="form-control"
                    placeholder="Client Name"
                    onChange={(e) => this.setState({ title: e.target.value })}
                  />
                </div>
              </div>
            </CardHeader>

            <Modal
              isOpen={this.state.openModal}
              toggle={this.toggleLarge}
              className={"modal-xl" + this.props.className}
            >
              <div className="row modal-header">
                Edit {img}
                <Button
                  color="secondary"
                  className="pull-right"
                  onClick={() =>
                    this.setState({
                      openModal: !this.state.openModal,
                    })
                  }
                >
                  X
                </Button>
                {/* <p className="text-muted">{this.state.imgPath}</p> */}
              </div>

              <ModalBody style={{ overflow: "scroll" }}>
                <PlotDentOnExtraImage
                  part={img}
                  vin={vin}
                  partnerId={partnerId}
                  imgPath={this.state.imgPath}
                />
              </ModalBody>
              <ModalFooter>
                {/* <Button color="primary" onClick={this.toggleLarge}>
                  Save
                </Button>{" "} */}
                {/* <Button
                  color="secondary"
                  onClick={() =>
                    this.setState({
                      openModal: !this.state.openModal,
                    })
                  }
                >
                  Cancel
                </Button> */}
              </ModalFooter>
            </Modal>

            <div className="row">
              <div className="col-12 col-sm-12">
                <div className="card">
                  <div className="card-header">Clients</div>

                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Sn</th>
                          <th>Name</th>
                          <th>Logo Image</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.vinfolderList.map((r, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{r.name}</td>
                              <td>
                                <div style={{ width: 100 }}>
                                  <img
                                    onClick={() =>
                                      this.openModal(
                                        r.name,
                                        "http://driveandscan.de/scanImages/" +
                                          partnerId +
                                          "/" +
                                          vin +
                                          "/" +
                                          r.name
                                      )
                                    }
                                    alt={r.image}
                                    style={{ cursor: "pointer" }}
                                    src={
                                      "http://driveandscan.de/scanImages/" +
                                      partnerId +
                                      "/" +
                                      "clients/" +
                                      r.image
                                    }
                                    className="imgGd"
                                    width="100%"
                                  />
                                </div>
                              </td>
                              <td>
                                <button
                                  className="badge badge-danger"
                                  onClick={() => {
                                    this.delete(r);
                                  }}
                                >
                                  X
                                </button>
                              </td>
                            </tr>
                          ))

                          // {
                          //   this.state.vinfolderList[0].resultTXT.scanresult
                          // }
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-footer">
              {/* <button className="btn btn-danger btn-sm" onClick={this.save}>
                    Update Vehicle Checkin
                  </button> */}
              {/* <button className="btn btn-warning btn-sm">Action</button> */}
            </div>
          </Card>
        </Col>
      </div>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(Clients);
//export default Colors;